import { render, staticRenderFns } from "./MenuCourse.vue?vue&type=template&id=32c2c98d"
import script from "./MenuCourse.vue?vue&type=script&lang=js"
export * from "./MenuCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports